<template>
<div>
  <v-container fluid grid-list-md>

  <v-progress-circular
      v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>
  <v-data-table
    dense
    :headers="headers"
    :items="users"
    sort-by="id"
    class="elevation-1"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50]
    }"
    :items-per-page="20"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{lang.Users}}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >

                  <v-row>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <v-checkbox
                          v-model="editedItem.beton"
                          label="Beton korisnik"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <v-checkbox
                          v-model="editedItem.betonUtrosak"
                          label="Utrošak materijala"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <v-text-field
                          v-model="editedItem.tvrtkaID"
                          label="Tvrtka ID"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                      <v-select
                          v-model="editedItem.jezik"
                          :items="jezikItems"
                          label="Jezik / Language"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="editedItem.newPassword"
                          label="Nova lozinka (ostavi prazno da ne mijenjaš)"
                          type="password"
                          autocomplete="new-password"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row v-if="errorMatch">                    
                      <div class="red" v-html="errorMatch" />
                  </v-row>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">{{langC.Cancel}}</v-btn>
                    <v-btn color="success" text @click="save">{{langC.Save}}</v-btn>  
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
 
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:[`item.beton`]="{ item }">
      <span v-if="item.beton"><v-icon>mdi-check</v-icon></span>
    </template>

    <template v-slot:[`item.betonUtrosak`]="{ item }">
      <span v-if="item.betonUtrosak"><v-icon>mdi-check</v-icon></span>
    </template>

    <template v-slot:[`item.action`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-trash-can
      </v-icon>
    </template>
    <template v-slot:no-data>
      {{ lang.UsersEmpty }}
    </template>
  </v-data-table>
  </v-container>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import langEn from '../Users/userDescEn'
import langHr from '../Users/userDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import dateFormat from '@/snippets/dateFormat'

  export default {
    name: 'userCRUD',
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal2: false,
      menu2: false,
      lang: {},
      langC: {},
      saving: false,
      error: null,
      errorMatch: null,
      modal: false,
      show1: false,
      show2: false,
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: "",
        databaseDocID: 0
      },
      dialog: false,
      headers: [
        
      ],
      users: [],
      editedIndex: -1,
      editedItem: { },
      defaultItem: {
        CompanyId: 0,
        CompanyNameDatabase: '',
        email: '',
        password: '',
        First: '',
        Last: '',
        StartFrom: null,
        Activ: false,
        Admin: false,
        beton: false,
        betonUtrosak: false,
        tvrtkaID: 0,
        jezik: 'EN',
        newPassword: '',
        AccessLevel: 5,
        forgotUrl: '',
        vatID: '',
        sales1: false,
        sales2: false,
        purchase1: false,
        purchase2: false,
        crm1: false,
        crm2: false,
        finance1: false,
        finance2: false,
        finance3: false,
        finance4: false,
        hr1: false,
        hr2: false,
        admin1: false,
        admin2: false,
        prod1: false,
        prod2: false,
        privatePartner: true,
        chart1: false,
        chart2: false,
        chart3: false,
        chart4: false,
        salesNumbers1: false,
        salesNumbers2: false,
        calendar1: false,
        calendar2: false,
        task1: false,
        task2: false,
        chat1: false,
        chat2: false,
      },
      confpassword: '',
      jezikItems: [{ text: 'English', value: 'EN' }, { text: 'Hrvatski', value: 'HR' }],
      privitems: [ ],
      valid: true,
      nameRules: [
        v => !!v || 'Name is required',
      ],

    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? this.lang.NewUser: this.lang.EditUser
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    components: {

    },

    mounted() {
      if (this.$store.state.language === "EN") {
        this.lang = langEn
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = langHr
        this.langC = commHr;
      }
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.mainQuery.businessYear = this.$store.state.businessYear
      }
      // let locDate1 = new Date()
      // locDate1 = this.$moment().set({ 'year': locDate1, 'month': 0, 'date': 1 })
      // this.defaultItem.startFrom = this.$moment(locDate1).format('YYYY-MM-DD')

      // this.privitems.push(
      //   { text: this.lang.Priv1, value: 1 },
      //   { text: this.lang.Priv2, value: 2 },
      //   { text: this.lang.Priv3, value: 3 },
      //   { text: this.lang.Priv4, value: 4 },
      //   { text: this.lang.Priv5, value: 5 }
      // )

      this.headers.push(
        {text: this.lang.Last, value: 'Last', width: '180px'},
        {text: this.lang.First, value: 'First', width: '180px'},
        {text: 'email', value: 'email', width: '250px'},
        {text: 'Beton korisnik', value: 'beton', type: 'boolean', width: '50px'},
        {text: 'Utrošak materijala', value: 'betonUtrosak', type: 'boolean', width: '50px'},
        {text: 'Beton Tvrtka ID', value: 'tvrtkaID', type: 'number', width: '50px'},
        {text: 'Jezik', value: 'jezik', width: '60px'},
        {text: this.lang.Actions, value: 'action', sortable: false },
        {text: 'DbId', value: 'id', type: 'number', width: '50px'},
      ) 
    },

    created () {
      this.initialize()
    },

    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      async initialize () {
        try {
          this.saving = true
          const {data} = (await UserService.index())
          console.log('data users ', data)
          if (data && data.users) {
            this.users = data.users
          }           
          this.saving = false
          this.errorMatch = false
        } catch (err) {
          this.error = err
          
        }
      },
      editItem (item) {
        this.errorMatch = false
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, this.defaultItem, item)
        this.dialog = true
        // const accLevel = parseInt(this.editedItem.AccessLevel)
        // const newAccLevel = { AccessLevel: accLevel,
        //                       password: ''}
        // this.editedItem = Object.assign({}, this.editedItem, newAccLevel)
      },

      async deleteItem (item) {
        try {
          const index = this.users.indexOf(item)
          const warningMessage = item.First + ' ' + item.Last
          if (confirm(this.langC.AreYouShureToDelete + ' ' + warningMessage + '!') && this.users.splice(index, 1)) {
            await UserService.delete(item.id)
            this.initialize()
          }
        } catch(err) {
          this.error = err
         
        }
        
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      checkMatch () {
        if (this.editedItem.password && this.confpassword &&  this.confpassword === this.editedItem.password) {
          this.errorMatch = null
          this.save()
        } else {
          this.errorMatch = 'Error. Passoword and Confirmation Password are NOT equal!'
          this.valid = false        
        }
      },

      async save () {
        try {
           let doneOK = false
           if (this.editedIndex > -1) {
              await UserService.put(this.editedItem)
              doneOK = true
            } else {
              //this.editedItem.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
              //this.editedItem.email = this.$store.state.user.email ? this.$store.state.user.email : ''
              this.editedItem.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : ''
              this.editedItem.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
              //this.editedItem.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : ''
              await UserService.post(this.editedItem)
              doneOK = true
            }
            if (doneOK) {
              this.initialize()
              this.close()
            }
        } catch(err) {
          this.error = err
          
        }
       
      },
      localDate(dateToFormat) {
       return dateFormat(dateToFormat)
      }
    },
  }
</script>